import Swiper from 'swiper'

export default {
  init() {
    $('.carousel__other-articles').each(function() {
      let carousel = $(this)
      let carouselSwiper = new Swiper(carousel.find('.carousel__container'), {
        navigation: {
          nextEl: carousel.find('.carousel__button--next'),
          prevEl: carousel.find('.carousel__button--prev'),
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 28,
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 48,
          },
          1600: {
            spaceBetween: 63,
          },
        },
      })
      carousel.find('.swiper-container').data('carouselSwiper', carouselSwiper)
    })

    $('.carousel__featured-articles').each(function() {
      let carousel = $(this)
      let carouselSwiper = new Swiper(carousel.find('.carousel__container'), {
        slidesPerView: '1',
        spaceBetween: 200,
        navigation: {
          nextEl: carousel.find('.carousel__button--next'),
          prevEl: carousel.find('.carousel__button--prev'),
        },
      })
      carousel.find('.swiper-container').data('carouselSwiper', carouselSwiper)
    })

    $('.carousel__testimonials').each(function() {
      let carousel = $(this)
      let carouselSwiper = new Swiper(carousel.find('.swiper-container'), {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 28,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 90,
          },
          1600: {
            slidesPerView: 1,
            spaceBetween: 100,
          },
        },
        autoplay: {
          delay: 7500,
        },
        centeredSlides: true,
        simulateTouch: false,
        roundLengths: true,
        autoHeight: true,
        navigation: {
          nextEl: carousel.find('.carousel__testimonials__next'),
          prevEl: carousel.find('.carousel__testimonials__prev'),
        },
        loop: true,
      })
      carousel.find('.swiper-container').data('carouselSwiper', carouselSwiper)
    })

    $('.mobile-carousel__products').each(function() {
      let carousel = $(this),
      originalContainerClass = carousel.attr('class'),
      originalWrapperClass = carousel.find('.home-products').attr('class')
      $.mlmi.mobile.addCallbacks(function() {
        carousel.addClass('swiper-container')
        carousel.find('.home-products').addClass('swiper-wrapper').removeClass('products columns-3 justify-content-center')
        carousel.find('.product').addClass('swiper-slide')
        carousel.append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>')
        let mobileCarouselSwiper = new Swiper(carousel, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: true,
          autoHeight: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        carousel.data('carouselSwiper', mobileCarouselSwiper)
      }, function() {
        if (carousel.data('carouselSwiper')) {
          carousel.attr('class', originalContainerClass)
          carousel.find('.swiper-slide-duplicate, .swiper-button-prev, .swiper-button-next').remove()
          carousel.find('.home-products').attr('class', originalWrapperClass)
          carousel.find('.product').removeClass('swiper-slide swiper-slide-active swiper-slide-next swiper-slide-prev')
          carousel.data('carouselSwiper').destroy()
          carousel.removeData('carouselSwiper')
        }
      })
    })
  },
}
